<template>
  <div>
    <header class="share-header">
      <div class="share-header-logo">
        <img v-bind:src="'static/logo.png'" style="height: 50px; padding-top: 8px;"/>
      </div>
      <a href="https://www.sdgsystems.com/phototag" target="_blank" class="share-header-logo">
        <img v-bind:src="'static/sdg_logo.png'" alt="SDG" style="height: 50px; padding-top: 8px;"/>
      </a>
    </header>
    <div class="share-actions">
      <v-btn small outlined color="primary" @click="toggleSelectAll">
        {{ allSelected ? 'Deselect All' : 'Select All' }}
      </v-btn>
    </div>
  <ImageList
  ref="imageList"
  :public="true"
  :shareId="shareId"
  />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import ImageList from '@/components/ImageList.vue'
  export default {
    components: {
      ImageList
    },
    data () {
      return {
        shareId: this.$route.params.shareId
      }
    },
    computed: {
      ...mapGetters(['getImages']),
      allSelected () {
        var images = this.getImages
        if (!images || images.length === 0) return false
        return images.every(function (img) { return img.selected })
      }
    },
    methods: {
      toggleSelectAll () {
        if (!this.$refs.imageList) return
        if (this.allSelected) {
          this.$refs.imageList.clickClear()
        } else {
          this.$refs.imageList.clickSelectAll()
        }
      }
    },
    created () {
      console.log(this.$route.params.shareId)
    }
  }
</script>

<style>
.share-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  max-height: 50px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.share-actions {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e0e0e0;
}
</style>



// WEBPACK FOOTER //
// Public.vue?55e5cef8